<template>
  <ControlUnit
    :title="$t('control.panel.control_widget')"
    :tooltip="$t('control.panel.control_widget_description')"
  >
    <InputInput
      name="custom-event"
      param="title"
      :value="$t('control.panel.new_title')"
      @change="changeControlHandler"
    />
  </ControlUnit>
</template>

<script>
import useStateController from './useStateController';

import ControlUnit from './ControlUnit.vue';
import InputInput from './InputInput.vue';

export default {
  components: {
    ControlUnit,
    InputInput,
  },
  setup() {
    const { changeControlHandler } = useStateController();

    return {
      changeControlHandler,
    };
  },
};
</script>
